module.exports = __webpack_public_path__ + "img/04.813b4040.png";